var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcThreat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3071",
    "data-name": "Rectangle 3071",
    width: 24,
    height: 24,
    transform: "translate(-21633.5 -1783.5)",
    fill: "#003fb9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_threat",
    transform: "translate(21633.5 1783.5)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8913",
    "data-name": "Group 8913",
    transform: "translate(-21633.5 -1783.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_166",
    "data-name": "Subtraction 166",
    d: "M12.493,13.7a1.179,1.179,0,0,1-.851-.366,1.236,1.236,0,0,1-.353-.864,1.183,1.183,0,0,1,.227-.7,1.211,1.211,0,0,1,.576-.431V10.058a.4.4,0,0,0-.4-.4H9.684v.4a1.205,1.205,0,0,1-1.2,1.2H8.052v-1.2a.4.4,0,0,0-.8,0v1.2h-.8v-1.2a.4.4,0,0,0-.14-.3L8.1,7.992a1.224,1.224,0,0,0,.378.06,1.205,1.205,0,0,0,1.2-1.2V6.44l1.277-1.253a4.38,4.38,0,0,1,.306,1.26h1.627v-.4a.4.4,0,1,1,.8,0V7.651a.4.4,0,0,1-.8,0v-.4H11.252a2.641,2.641,0,0,1-.821,1.6H11.69a1.205,1.205,0,0,1,1.2,1.2v1.278a1.211,1.211,0,0,1,.576.431,1.183,1.183,0,0,1,.227.7,1.236,1.236,0,0,1-.353.864A1.179,1.179,0,0,1,12.493,13.7ZM5.644,11.262h-.4a1.224,1.224,0,0,1-.4-.069l.805-.79v.859ZM.8,10.26h0v-.2a1.205,1.205,0,0,1,1.2-1.2h.229L.8,10.26ZM2.814,8.286h0a2.813,2.813,0,0,1-.367-1.037H.8v.4a.4.4,0,0,1-.8,0V6.046a.4.4,0,1,1,.8,0v.4H2.44a4.216,4.216,0,0,1,.454-1.608H2.006a1.2,1.2,0,0,1-1.2-1.2V2.36a1.211,1.211,0,0,1-.576-.431A1.183,1.183,0,0,1,0,1.23,1.236,1.236,0,0,1,.353.366a1.171,1.171,0,0,1,1.7,0,1.236,1.236,0,0,1,.353.864,1.183,1.183,0,0,1-.227.7,1.211,1.211,0,0,1-.576.431V3.638a.4.4,0,0,0,.4.4h1.4A4.427,4.427,0,0,1,5.9,2.533a4.6,4.6,0,0,1,.943-.1,4.5,4.5,0,0,1,1.626.3l-3.3,3.236-.58-.285a.408.408,0,0,0-.18-.042.4.4,0,0,0-.4.4v.8a1.157,1.157,0,0,0,.025.238l-1.223,1.2ZM11.69,4.842h-.377l1.581-1.551v.347A1.205,1.205,0,0,1,11.69,4.842Z",
    transform: "translate(4.949 4.948)",
    fill: "#003fb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_252",
    "data-name": "Union 252",
    d: "M0,12A12,12,0,1,1,12,24,12,12,0,0,1,0,12Zm12,9.867A9.862,9.862,0,0,0,19.748,5.9l-14,13.732A9.82,9.82,0,0,0,12,21.867ZM2.133,12a9.819,9.819,0,0,0,2.123,6.108l14-13.734A9.862,9.862,0,0,0,2.133,12Z",
    fill: "#003fb9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcThreat);
export default __webpack_public_path__ + "static/media/ic_threat.b3d564a4ad2af0cc4dabf1b87ac37282.svg";
export { ForwardRef as ReactComponent };